import React from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom';
import CustomFormGroup from './CustomFormGroup';
import FormControl from 'react-bootstrap/lib/FormControl'

export default class Ssn extends React.Component {
  constructor(props) {
    super(props);
    this.handleSsnChange = this.handleSsnChange.bind(this);
  }

  handleSsnChange(e){
    if(e.target.value.includes("***")){
      $(e.target).val('');
    }
    var val = e.target.value.replace(/\D/g, '');
    var newVal = '';
    if(val.length > 4) {
       e.target.value = val;
    }
    if((val.length > 3) && (val.length < 6)) {
       newVal += val.substr(0, 3) + '-';
       val = val.substr(3);
    }
    if (val.length > 5) {
       newVal += val.substr(0, 3) + '-';
       newVal += val.substr(3, 2) + '-';
       val = val.substr(5);
     }
     newVal += val;
     var ssn = newVal.substring(0, 11)
     e.target.value = ssn;
     if (ssn.length == 11){
       this.props.handleSelection(ssn);
     } else {
       this.props.handleSelection('');
     }
  }

  render(){
    const content = this.props.content;

    if (content.territory_code == "usa") {
      return (
        <CustomFormGroup valid={this.props.valid}>
          <FormControl
            id="ssn"
            placeholder="Social Security Number"
            type="text"
            ref="ssn"
            componentClass="input"
            defaultValue={this.props.ssn}
            onKeyDown={this.handleSsnChange} />
        </CustomFormGroup>
      );
    } else {
      return null;
    }
  }
};
